import axios from "axios";
import { authConfig, endpoint } from "./http";

export async function listMyConversations({ accessToken, apiUrl }) {
  const response = await axios.get(endpoint(apiUrl, "/me/conversations"), authConfig(accessToken));

  return response.data;
}

export async function createConversation({ accessToken, apiUrl, listingId }) {
  const response = await axios.post(
    endpoint(apiUrl, "/conversations"),
    { listing_id: listingId },
    authConfig(accessToken)
  );

  return response.data;
}

export async function getConversation({ accessToken, apiUrl, conversationId }) {
  const response = await axios.get(
    endpoint(apiUrl, `/conversations/${conversationId}`),
    authConfig(accessToken)
  );

  return response.data;
}

export async function sendConversationMessage({ accessToken, apiUrl, body, conversationId }) {
  const response = await axios.post(
    endpoint(apiUrl, `/conversations/${conversationId}/messages`),
    { body },
    authConfig(accessToken)
  );

  return response.data;
}

export async function markConversationRead({ accessToken, apiUrl, conversationId }) {
  const response = await axios.patch(
    endpoint(apiUrl, `/conversations/${conversationId}/mark-read`),
    {},
    authConfig(accessToken)
  );

  return response.data;
}

export async function reportMessage({ accessToken, apiUrl, details, messageId, reason }) {
  const response = await axios.post(
    endpoint(apiUrl, `/messages/${messageId}/report`),
    {
      reason,
      details,
    },
    authConfig(accessToken)
  );

  return response.data;
}
